import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const Userid = 'Admin-UserId'
const Type = 'Admin-type'
const Planid = 'Admin-Planid'
export function getToken() {
    return Cookies.get(TokenKey)
}
export function getUserid() {
    return Cookies.get(Userid)
}
export function getType() {
    return Cookies.get(Type)
}
export function setToken(token) {
    return Cookies.set(TokenKey, token)
}
export function setUserid(userid) {
    return Cookies.set(Userid, userid)
}
export function setType(type) {
    return Cookies.set(Type, type)
}

// export function getPlanid() {
//     return Cookies.get(Planid)
// }
// export function setPlanid(pid) {
//     return Cookies.set(Planid, pid)
// }

export function removeToken() {
    return Cookies.remove(TokenKey)
}